import { formatPhoneNumber } from '@entities/create-segment-modal/lib/form-validator';

const INTERNATIONAL_CODE_RUSSIA = '7';
const INTERCITY_CODE_RUSSIA = '8';

export const phoneNumberValidator = (value: string) => {
  const replacedValue = String(value).replace(/\D/g, '');
  let formattedValue = '';

  if (replacedValue.length > 0) {
    // Добавляем логику для первой цифры
    if (replacedValue[0] === INTERCITY_CODE_RUSSIA || replacedValue[0] !== INTERNATIONAL_CODE_RUSSIA) {
      formattedValue = INTERNATIONAL_CODE_RUSSIA;
    }
    formattedValue += replacedValue;
  }
  // Обрезаем до 11 символов
  formattedValue = formattedValue.slice(0, 11);
  const maskedValue = formatPhoneNumber(formattedValue);
  return maskedValue;
};

export const formatRussianPhone = (phone: string): string => {
  if (!phone) return '-';

  // Очищаем номер от всех нецифровых символов
  const cleaned = phone.replace(/\D/g, '');

  let formatted = '';

  // Обработка для номеров длиной 10 цифр (добавляем 7 в начало)
  if (cleaned.length === 10) {
    formatted = '7' + cleaned;
  }
  // Обработка для номеров длиной 11 цифр (заменяем первую цифру на 7)
  else if (cleaned.length === 11) {
    formatted = '7' + cleaned.slice(1);
  }
  // Для других случаев используем очищенный номер
  else {
    formatted = cleaned;
  }

  // Разбиваем отформатированный номер на части
  const part1 = formatted.substring(0, 1); // 7
  const part2 = formatted.substring(1, 4); // 915
  const part3 = formatted.substring(4, 7); // 123
  const part4 = formatted.substring(7, 9); // 45
  const part5 = formatted.substring(9, 11); // 67

  // Собираем номер в нужном формате
  let result = part1;
  if (part2) result += ` ${part2}`;
  if (part3) result += ` ${part3}`;
  if (part4) result += `-${part4}`;
  if (part5) result += `-${part5}`;

  return result;
};
